import React, { useContext } from 'react';
import {
  ArticleAction,
  ArticleState,
  CategoryState,
  initialCategoryState,
} from '../reducer/ArticlesReducer';

type ArticleContext = {
  state: ArticleState;
  dispatch: React.Dispatch<ArticleAction>;
};

export const ArticleContext = React.createContext<ArticleContext | null>(null);

export const useArticleContext: () => [
  ArticleState,
  React.Dispatch<ArticleAction>,
] = () => {
  const context = useContext(ArticleContext);
  if (!context) {
    throw new Error('Context not found' + ArticleContext);
  }
  return [context.state, context.dispatch];
};

export const useArticleByCategory = (categoryId: string): CategoryState => {
  const [state] = useArticleContext();
  if (state.initial) {
    return initialCategoryState;
  }
  return state.data[categoryId] ?? initialCategoryState;
};
